import { Injectable, signal } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { ChangePasswordDialogComponent, DialogChangePasswordObject } from './change-password-dialog/change-password-dialog.component';
import { MatDialogRef } from '@angular/material/dialog';


export type ChangePasswordDialogSubmitted = {passwordObject: DialogChangePasswordObject, dialogRef: MatDialogRef<ChangePasswordDialogComponent, any>}
export type MfaCodeRequested  ={email: string};
@Injectable({ providedIn: 'root' })
export class SharedChangePasswordService {
  constructor() {}
  passwordChangeInProgress = signal<boolean>(false);
  dialogPasswordSubmitted = new EventEmitter<ChangePasswordDialogSubmitted>();
  mfaCodeRequested = new EventEmitter<MfaCodeRequested>();
  mfaCodeSent = signal<boolean>(false);
}
